<template>
  <v-dialog
    eager
    max-width="450"
    v-model="dialog"
    content-class="dialog-plan-mobile-dialog"
  >
    <v-card class="dialog-plan-mobile-card">
      <v-card-title class="secondary white--text dialog-plan-mobile-title">
        <span class="font-hemi-head">PIANIFICAZIONE</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dismiss">
          <v-icon class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>
      <asta-plan
        v-if="dialog"
        class="navy darken-2 dialog-plan-mobile-content"
        :show-title="false"
        show-settings
      ></asta-plan>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import AstaPlan from "../AstaPlan";

export default {
  name: "dialog-plan",
  components: {
    AstaPlan,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    console.log("--> DialogPlan mounted.");
    db.on("showDialogPlan", this.show);
  },
  destroyed() {
    console.log("<-- DialogPlan destroyed.");
    db.off("showDialogPlan", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-plan-mobile-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  overflow: hidden;
}
.dialog-plan-mobile-title {
  flex: 0 0 auto;
}
.dialog-plan-mobile-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
</style>
